import { jsxs, jsx } from "react/jsx-runtime";
import { Text, TextTypography, Button, ButtonPriority } from "@wix/wix-ui-tpa/cssVars";
import { useMemo, useState, useRef, useEffect } from "react";
import { TRANSLATIONS_NAMESPACE } from "../../../constants/translations.js";
import { DATA_HOOKS } from "../data-hooks.js";
import styles from "./form-loading-error.module.scss";
const FormLoadingError = ({
  formId,
  i18n,
  translations,
  language = "en",
  onError,
  isRTL
}) => {
  const t = useMemo(
    () => i18n.getFixedT(language, TRANSLATIONS_NAMESPACE),
    [language, i18n]
  );
  useState(
    () => i18n.addResources(language, TRANSLATIONS_NAMESPACE, translations)
  );
  const isError = useRef(false);
  useEffect(() => {
    if (!isError.current) {
      isError.current = true;
      onError?.(new Error(`Couldn’t load the form: ${formId}`));
    }
    return () => {
      isError.current = false;
    };
  }, [formId, onError]);
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: styles.container,
      "data-hook": DATA_HOOKS.FORM_VIEWER_NO_FORM_ERROR,
      dir: isRTL ? "rtl" : "",
      children: [
        /* @__PURE__ */ jsx(Text, { typography: TextTypography.smallTitle, children: t?.("error.could-not-load-form.title") }),
        /* @__PURE__ */ jsx(Text, { typography: TextTypography.runningText, children: t("error.could-not-load-form.description") }),
        /* @__PURE__ */ jsx(
          Button,
          {
            className: styles.button,
            onClick: () => window.location.reload(),
            priority: ButtonPriority.primary,
            children: t?.("error.could-not-load-form.button.label")
          }
        )
      ]
    }
  );
};
export {
  FormLoadingError as default
};
//# sourceMappingURL=form-loading-error.js.map
